/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks = [];

    const NAME = feature.getSettingValue('NAME');
    const SDA = feature.getSettingValue('SDA');
    const TEMPERATURE = feature.getSettingValue('TEMPERATURE');
    const HUMIDITY = feature.getSettingValue('HUMIDITY');
    // const GND = this.getSettingValue('GND');
    // const VCC = this.getSettingValue('VCC');
    // const GNDPIN = Peripherals.getPin(GND, this.project.device.id);
    // const VCCPIN = Peripherals.getPin(VCC, this.project.device.id);

    const SDAPIN = Peripherals.getPin(SDA, feature.project.device.id)?.peripherals
        .filter(p => p.peripheralType === 'gpio')[0];

    const gpioNum = SDAPIN?.num;

    blocks.push({
        location: 'IMPORTS',
        blockType: BlockType.CODE,
        id: 'import_dht',
        template: 'import dht',
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `${NAME} = dht.DHT11(machine.Pin(${gpioNum}, machine.Pin.IN, machine.Pin.PULL_UP))`,
    });

    blocks.push({
        location: `var_${TEMPERATURE}_update`,
        blockType: BlockType.CODE,
        template: `
${NAME}.measure()
value = ${NAME}.temperature()
var_${TEMPERATURE}_update_completed(value)
    `,
    });

    blocks.push({
        location: `var_${HUMIDITY}_update`,
        blockType: BlockType.CODE,
        template: `
${NAME}.measure()
value = ${NAME}.humidity()
var_${HUMIDITY}_update_completed(value)
    `,
    });

    blocks.push({
        location: 'WOKWI_PARTS',
        blockType: BlockType.CODE,
        template: `
{
    "type": "wokwi-dht22",
    "id": "${NAME}",
    "top": 0,
    "left": -100,
    "attrs": { "temperature": "35", "humidity": "40" }
},`,
    });

    return blocks;
};
